<script lang="ts">
    import { Router, Route } from "svelte-navigator";
    import Home from "./pages/Home.svelte";
    import Contacts from "./pages/Contacts.svelte";
    import ContactDetails from "./pages/ContactDetails.svelte";
    import Profile from "./pages/Profile.svelte";
    import PrivateRoute from "./components/PrivateRoute.svelte";
    import DarkModeToggle from "./elements/DarkModeToggle.svelte";
    import BrandLogo from "./elements/BrandLogo.svelte";
    import AuthButton from "./elements/AuthButton.svelte";
    import MainNavigationMenu from "./components/MainNavigationMenu.svelte";
</script>

<Router>
    <header>
        <BrandLogo />
        <DarkModeToggle />
        <AuthButton />
        <MainNavigationMenu />
    </header>

    <main>
        <Route path="/">
            <Home />
        </Route>

        <PrivateRoute path="contacts">
            <Contacts />
        </PrivateRoute>

        <PrivateRoute path="contacts/:id" let:params>
            <ContactDetails id="{params.id}" />
        </PrivateRoute>

        <PrivateRoute path="profile" let:location>
            <Profile />
        </PrivateRoute>
    </main>
</Router>

<style>
    :root{
		--bg-color: #FFFFFF;
		--text-color: #000000;

        --flickr-pink: #F72585;
        --purple: #7209B7;
        --ultramarine: rgba(51, 33, 237, 1);
        --ultramarine-blue: #4361EE;
        --vivid-sky-blue: rgba(76, 201, 240, 1);

        --accent-color: var(--ultramarine);
        --accent-color-20: rgba(51, 33, 237, .2);
	}
	
	:global(body) {
		background: var(--bg-color);
		color: var(--text-color);
	}
	
	:global(body.dark) {
		--bg-color: #1E1E1E;
		--text-color: #EAEAEA;

        --accent-color: var(--vivid-sky-blue);
        --accent-color-20: rgba(76, 201, 240, .2);
	}
</style>